//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'

export default {
  name: 'Actions',
  props: ['labels', 'session', 'config', 'active'],
  computed: {
    isOnFirstStep() {
      return this.session.step === 1
    },
    isOnLastStep() {
      return this.session.step === this.config[this.config.length - 1].step
    },
    isValidCurrentStep() {
      let val = this.config.find((el) => el.step === this.session.step)
      // return !!this.session[val.title];
      return true
    },
    queryString() {
      let str = ''
      this.config.forEach((el, index) => {
        let _obj = el.options.find((opt) => {
          return opt.id === this.session[el.title]
        })
        if (!_obj) return
        str += `/${_obj.id}`
      })
      return str
    },
  },
  methods: {
    ...mapActions(['fetchData']),
    startOver() {
      this.config.forEach((el) => {
        this.$store.commit('write_state', { key: 'visibleResultId', value: null })
        this.$store.commit('setStepOption', { step: el.title, value: null })
        this.$store.commit('setStep', 1)
        this.$emit('error', false)
      })
    },
    goBack() {
      if (this.session.step === 1) return
      this.$store.commit('write_state', { key: 'visibleResultId', value: null })
      this.$store.commit('setStepOption', { step: this.active.title, value: null })
      this.$store.commit('setStep', this.session.step - 1)
      this.$emit('error', false)
    },
    next() {
      if (this.isOnLastStep) return
      const val = this.config.find((el) => el.step === this.session.step)

      if (this.session[val.title]) {
        const step = `step${this.session.step + 1}` // Only needed for local testing
        const fetchEP = (window.location.hostname === 'localhost') ? this.$root[step] : `${this.$root.api}get/installationoptions${this.queryString}`

        this.fetchData(fetchEP)
          .then(() => {
            this.$store.commit('setStep', this.session.step + 1)
            document.getElementById('downdraft-top').scrollIntoView()
          })
      } else {
        this.$emit('error', true)
      }
    },
  },
}
